export default __webpack_public_path__ + "static/media/total_scope.30b88af7.svg";